"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMounted = void 0;
var react_1 = require("react");
/**
 * Returns function that yields current mount state.
 *
 * Returned function yields `true` only in case component is mounted. This hook
 * is handy for the cases when you have to detect component mount state within
 * async effects.
 */
function useIsMounted() {
    var isMounted = (0, react_1.useRef)(false);
    var get = (0, react_1.useCallback)(function () { return isMounted.current; }, []);
    (0, react_1.useEffect)(function () {
        isMounted.current = true;
        return function () {
            isMounted.current = false;
        };
    }, []);
    return get;
}
exports.useIsMounted = useIsMounted;
